namespace GeniuzPOS.AdvPromo {
    export class PsPromoAvMbColumns {
        static columnsKey = 'AdvPromo.PsPromoAvMb';
    }
}
